
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.973","height":"16.002"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon feather-phone","d":"M14.972 11.482v2.108a1.405 1.405 0 01-1.531 1.405 13.9 13.9 0 01-6.063-2.157 13.7 13.7 0 01-4.216-4.216 13.9 13.9 0 01-2.156-6.091A1.405 1.405 0 012.404 1h2.107a1.405 1.405 0 011.405 1.208 9.02 9.02 0 00.492 1.974 1.405 1.405 0 01-.316 1.483l-.892.892a11.24 11.24 0 004.215 4.215l.892-.892a1.405 1.405 0 011.482-.316 9.02 9.02 0 001.974.492 1.405 1.405 0 011.208 1.426z","fill":"none","stroke":"#f36628","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    